import React, { useState } from "react";
import ScanView from "./scanView/ScanView";
import VerificationOptions from "./verificationOptions/VerificationOptions";
import { getAPIGatewayDataFromParent } from "../../handler/ParentDataHandler";
import { logOperationalMetric } from "../../overview/utils/utils";
import { DolphinVerificationProcessName } from "../../util/Constants";

function verificationWindow() {
  const [alias, setAlias] = useState("");
  const [showQRCode, setShowQRCode] = useState(false);
  const [tokenValue, setTokenValue] = useState("");
  const [aliasError, setAliasError] = useState(false);

  const getTokenExpiry = () => {
    return (Date.now() + 30 * 60000).toString();
  };
  const onGenerateQRCode = (alias) => {
    async function generateToken(alias) {
      const getTokenRequest = {
        producerId: "SCC",
        tokenExpiry: getTokenExpiry(),
        associate: alias,
      };

      function getTokenAPIGatewayRequest(request) {
        return {
          resourcePath: "/dolphinVerification",
          httpMethod: "post",
          processName: "dolphinVerification",
          requestBody: request,
        };
      }

      const args = getTokenAPIGatewayRequest(getTokenRequest);
      const startTime = Date.now();
      getAPIGatewayDataFromParent(args).then((result) => {
        if (result.status === 200) {
          logOperationalMetric(
            startTime,
            DolphinVerificationProcessName,
            "getValidAlias",
            true,
          );
          if (result.data.Token) {
            setShowQRCode(true);
            setTokenValue(result.data.Token);
          } else {
            setAliasError(true);
          }
        } else {
          logOperationalMetric(
            startTime,
            DolphinVerificationProcessName,
            "getValidAlias",
            false,
          );
        }
      });
    }
    generateToken(alias);
  };

  return (
    <div>
      {showQRCode ? (
        <ScanView
          alias={alias}
          setAlias={setAlias}
          setShowQRCode={setShowQRCode}
          tokenValue={tokenValue}
          setAliasError={setAliasError}
        />
      ) : (
        <VerificationOptions
          alias={alias}
          setAlias={setAlias}
          showQRCode={showQRCode}
          onGenerateQRCode={onGenerateQRCode}
          setShowQRCode={setShowQRCode}
          tokenValue={tokenValue}
          setAliasError={setAliasError}
          aliasError={aliasError}
        />
      )}
    </div>
  );
}

export default verificationWindow;



// WEBPACK FOOTER //
// ./src/components/dolphinVerification/verificationWindow/verificationWindow.js